module.exports = __webpack_public_path__ + "img/voice.701fb615.png";